import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleTitleStatuses'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleTitleStatusesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleTitleStatusesStore",
			variables: false,
		})
	}
}

export async function load_VehicleTitleStatuses(params) {
  await initClient()

	const store = new VehicleTitleStatusesStore()

	await store.fetch(params)

	return {
		VehicleTitleStatuses: store,
	}
}
